/**
 * Cabeçalho `X-Client-Route`: diz ao servidor em que ecrã a pessoa estava quando
 * fez o pedido, para a auditoria de IA poder responder «onde» sem guardar conteúdo.
 *
 * Só viaja o caminho: sem query (`?q=…` pode ter nomes) e sem ids pessoais (UUIDs
 * e números longos viram `:id`). Corta-se a 200 porque o servidor guarda um campo curto.
 */
const CLIENT_ROUTE_HEADER = "X-Client-Route";
const MAX_LENGTH = 200;

const UUID = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const LONG_NUMBER = /\/\d{4,}(?=\/|$)/g;

export function currentClientRoute(): string {
  if (typeof window === "undefined") return "";
  const path = window.location.pathname.split("?")[0].split("#")[0];
  return path.replace(UUID, ":id").replace(LONG_NUMBER, "/:id").slice(0, MAX_LENGTH);
}

/** Para os `fetch` diretos (streaming), que não passam pelo axios. */
export function clientRouteHeaders(): Record<string, string> {
  const route = currentClientRoute();
  return route ? { [CLIENT_ROUTE_HEADER]: route } : {};
}
